// frontend/src/types/contactTypes.ts

// --- Types for displaying public contact info ---

// Represents the structure of the office address JSON object from settings
export interface OfficeAddressSettingValue {
  line1: string;
  line2?: string | null;
  city: string;
  state: string;
  zip: string;
  country?: string | null;
  maps_url?: string | null;
}

// Represents the data structure for all public-facing contact information settings
export interface PublicContactInfo {
  contact_office_address_json: OfficeAddressSettingValue | null;
  contact_phone_general: string | null;
  contact_email_support: string | null;
  contact_email_sales: string | null;
}


// --- Types for contact form submissions ---

export const contactStatuses = [
  "UNREVIEWED",
  "REVIEWED",
  "FOLLOWED_UP",
  "COMPLETED",
  "SPAM",
] as const;

export type ContactStatus = (typeof contactStatuses)[number];

// Represents the payload for a new contact form submission
export interface ContactFormPayload {
  name: string;
  email: string;
  phone?: string;
  subject?: string;
  message: string;
}

// Represents a full contact submission record from the API
export interface ContactResponse extends ContactFormPayload {
  id: number;
  status: ContactStatus;
  created_at: string;
  updated_at: string;
}

// Payload for updating the status of a submission
export interface ContactStatusUpdatePayload {
  status: ContactStatus;
}
